const UserDraftStatus = () => {
  return (
    <>
      <h2>My Draft Status</h2>

      <table>
        <thead>
          <tr>
            <th>Draft ID</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>PDC201</td>
            <td>Completed</td>
            <td>
              <button>Download</button>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default UserDraftStatus;
